"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const route_1 = require("@/utilities/route");
const style_1 = require("./style");
function BreadcrumbsComponent({ route }) {
    return (react_1.default.createElement(style_1.StyledBreadcrumbs, { separator: ">" }, (0, route_1.pathTo)(route).map((crumb, i, breadcrumbs) => {
        return i < breadcrumbs.length - 1 ? (react_1.default.createElement(style_1.StyledLink, { to: crumb.path, key: i }, crumb.name)) : (react_1.default.createElement(style_1.CurrentlLabel, { key: i }, crumb.name));
    })));
}
exports.default = BreadcrumbsComponent;
